import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Forgot Password", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
        type: "mail",
        placeholder: "Enter your mail",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.mail]
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("button", { type: "submit" }, "Reset Password", -1))
    ], 32)
  ]))
}